export default __webpack_public_path__ + "static/media/overviewBanner.82448e74.jpg";